<template>
  <div class="bg-white rounded-8 border border-gray-50">
    <div class="border-b border-gray-50 flex flex-col gap-8">
      <div class="pl-20 pt-20 text-18" data-test="customer-portal-title">Customer Portal</div>
      <div class="pl-20 pb-20 text-13 font-normal text-gray-400" data-test="customer-portal-subtitle">
        Manage your companies subscriptions and billing information
      </div>
    </div>
    <div class="border-b border-gray-50 flex gap-8">
      <div class="w-1/5">
        <div class="text-14 pl-20 pt-20" data-test="user-account-section-title">Billing Information</div>
        <div class="pl-20 pb-20 text-13 font-normal text-gray-400" data-test="customer-portal-billing-subtitle">
          View Invoices, Update Billing Information, and manage Payment Methods
        </div>
      </div>
      <div class="p-20 text-13 gap-8 flex flex-col">
        <SparkButton class="w-full" @click="openStripePortal" variant="outlined">Open Stripe Portal</SparkButton>
      </div>
    </div>
    <div class="border-b border-gray-50 flex gap-8">
      <div class="text-14 pl-20 pt-20 w-1/5" data-test="user-account-section-title">Subscription</div>
      <div class="p-20 text-13 gap-8 flex flex-col w-1/5">
        <SparkButton class="w-full" @click="editSubscription" variant="outlined">Edit Subscription</SparkButton>
      </div>
      <div class="p-20 text-13 gap-8 flex flex-col w-1/5">
        <SparkButton class="w-full" @click="cancelSubscription" variant="outlined">Cancel Subscription</SparkButton>
      </div>
    </div>
  </div>
</template>

<script>
import SparkButton from '@/components/SparkComponents/SparkButton.vue';

export default {
  name: 'CustomerPortal',

  components: {
    SparkButton,
  },

  methods: {
    openStripePortal() {
      window.open('https://billing.stripe.com/p/login/4gw7vKcwEahBawEeUU', '_blank');
    },
    cancelSubscription() {
      window.open(
        'https://share-eu1.hsforms.com/2kpe0VSMqRZmSYgiQugwslQf3m8s?__hstc=16534249.b407dcaebfafd2363fdd45f6b2a132a2.1745843146976.1745843146976.1745843146976.1&__hssc=16534249.3.1745843146976&__hsfp=4080451729',
        '_blank'
      );
    },
    editSubscription() {
      window.open('https://meetings-eu1.hubspot.com/jloock/customer-success', '_blank');
    },
  },
};
</script>
